import React from 'react';

interface SwitchElementProps {
  value: string | any;
  [key: string]: any;
}

const withSwitchElement = <P extends object>(
  definitions: Record<string, React.ReactNode | React.ComponentType<any>>,
  defaultElement?: React.ReactNode,
  WrappedComponent?: React.ComponentType<P>
): React.FC<P & SwitchElementProps> => {
  const SwitchElement: React.FC<P & SwitchElementProps> = ({
    value,
    ...props
  }: SwitchElementProps & P) => {
    const ElementToRender = definitions[value] || defaultElement || null;
    const renderElement = () => {
      if (React.isValidElement(ElementToRender)) {
        return ElementToRender;
      }
      if (typeof ElementToRender === 'function') {
        const Component = ElementToRender as React.ComponentType<any>;
        return <Component {...props} />;
      }
      return null;
    };
    if (!WrappedComponent) {
      return <>{renderElement()}</>;
    }
    return (
      <WrappedComponent {...(props as P)}>{renderElement()}</WrappedComponent>
    );
  };

  SwitchElement.displayName = `withSwitchElement(${
    WrappedComponent
      ? WrappedComponent.displayName || WrappedComponent.name || 'Component'
      : 'Component'
  })`;

  return SwitchElement;
};

export default withSwitchElement;
